import '../css/sidemenu.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

function SideMenu({ className }) {
    const { user } = useAuth();
    const [adminOpen, setAdminOpen] = useState(false);
    const [featureOpen, setFeatureOpen] = useState(false);
    const [storageOpen, setStorageOpen] = useState(false);

    return (
        <div className={`SideMenu ${className}`}>
            {/* Sezione Admin, resa visibile solo se user.admin === true */}
            {user?.data.admin === true && (
                <div className="menu-section">
                    <button
                        onClick={() => setAdminOpen(!adminOpen)}
                        className="menu-toggle textlink"
                    >
                        <span>Admin Features</span>
                        <span className="dropdown-icon">
                            {adminOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                    </button>
                    {adminOpen && (
                        <ul className="textlink">
                            <li>
                                <Link className="textlink" to="/manageuser">Manage User</Link>
                            </li>
                            <li>
                                <Link className="textlink" to="/managemines">Manage Mines</Link>
                            </li>
                        </ul>
                    )}
                </div>
            )}

            {/* Sezione Features */}
            <div className="menu-section">
                <button
                    onClick={() => setFeatureOpen(!featureOpen)}
                    className="menu-toggle textlink"
                >
                    <span>Tools</span>
                    <span className="dropdown-icon">
                        {featureOpen ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                </button>
                {featureOpen && (
                    <ul className="textlink">
                        <li>
                            <Link className="textlink" to="/cleanPDB">CleanPDB</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/downloadPDB">DownloadPDB</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/viewerPDB">ViewerPDB</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/Graph">Graph</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/yadamp">Yadamp</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/matisse">Matisse</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/deepsage">DeepSage</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/vizit">Vizit</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/molseeker">Molseeker</Link>
                        </li>
                    </ul>
                )}
            </div>

            {/* Sezione Storages */}
            <div className="menu-section">
                <button
                    onClick={() => setStorageOpen(!storageOpen)}
                    className="menu-toggle textlink"
                >
                    <span>Storages</span>
                    <span className="dropdown-icon">
                        {storageOpen ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                </button>
                {storageOpen && (
                    <ul className="textlink">
                        <li>
                            <Link className="textlink" to="/cleanPDBStorage">CleanPDB Storage</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/downloadPDBStorage">DownloadPDB Storage</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/deepsageStorage">DeepSage Storage</Link>
                        </li>
                        <li>
                            <Link className="textlink" to="/vizitStorage">Vizit Storage</Link>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
}

export default SideMenu;
